export default __webpack_public_path__ + "static/media/comment_icon.06299291.svg";